// import node module libraries

import { submitAnswerAction } from "actions/quiz";
import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
//translate component
const Pagination = ({
  nPages,
  currentPage,
  setCurrentPage,
  selectedAnswer,
  currentQuestionId,
  setSelectedAnswer,
}) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const quizId = searchParams.get("quiz_id");
  const user_id = searchParams.get("user_id");
  const board_id = searchParams.get("board_id");
  const placmentTest = searchParams.get("placmentTest");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const linkToResult = `/quiz/quiz-finish?quiz_id=${quizId}&user_id=${user_id}&board_id=${board_id}&placmentTest=${placmentTest}`;
  const { loading } = useSelector((state) => state.auth);

  const [showPopUp, setShowPopUp] = useState(false);
  const handleSubmitQuiz = async () => {
    const requestBody = {
      answer: selectedAnswer,
      question_id: currentQuestionId,
      user_id: user_id,
      quiz_id: quizId,
    };

    try {
      dispatch(
        submitAnswerAction({
          requestBody,
          setSelectedAnswer,
          linkToResult,
          nextPage,
          setShowPopUp,
          navigate,
        })
      );
    } catch (error) {
      console.error("Error submitting answer:", error);
    }
  };
  const handleFinishQuiz = async () => {
    const requestBody = {
      answer: selectedAnswer,
      question_id: currentQuestionId,
      user_id: user_id,
      quiz_id: quizId,
      last: true,
    };

    try {
      dispatch(
        submitAnswerAction({
          requestBody,
          setSelectedAnswer,
          linkToResult,
          navigate,
          setShowPopUp,
        })
      );
    } catch (error) {
      console.error("Error submitting answer:", error);
    }
  };
  const nextPage = () => {
    if (currentPage !== nPages) setCurrentPage(currentPage + 1);
  };
  const prevPage = () => {
    if (currentPage !== 1) setCurrentPage(currentPage - 1);
  };
  const handleClosePopUp = () => {
    setShowPopUp(false);
  };
  return (
    <div>
      <h5>
        {" "}
        <span style={{ color: "red" }}>Notice </span> If you can't find the
        answer, click the 'Next Button' to continue.
      </h5>

      <div
        className={`d-flex justify-content-${
          currentPage > 1 ? "between" : "end"
        }`}
        style={{ marginTop: "20px" }}
      >
        {/* {currentPage > 1 && (
          <Button variant="secondary" onClick={prevPage}>
            <i className="fe fe-arrow-left"></i> {"Previous"}
          </Button>
        )} */}
        {currentPage === nPages ? (
          <Link className="btn btn-primary" onClick={() => handleFinishQuiz()}>
            {"Finish"}
          </Link>
        ) : (
          <Button
            variant="primary"
            disabled={loading}
            onClick={() => handleSubmitQuiz()}
          >
            {" "}
            {"Next"} <i className="fe fe-arrow-right"></i>
          </Button>
        )}
      </div>
      <Modal show={showPopUp} onHide={() => setShowPopUp(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h3>Time's Up!</h3>
          <p className="text-secondary">
            Sorry, your time for this quiz has expired.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClosePopUp}>
            Return to Quiz List
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Pagination;
